import React, { useState } from "react";
import { Modal } from "react-bootstrap";

import HttpManager from "../../services/HttpManager";
import { TuitionDTO } from "../../models/TuitionDTO";

/*
	«Cambiar Monto» de la inscripción (Esteban, 2026-10-31: «Que sea fácil y que pongan justificación y ya está»). Solo Caja del
	plantel, solo sin pagos, solo subir (bajar es un descuento). POST students/{studentId}/tuitions/{tuitionId}/_subscriptionAmount.
*/
export const MIN_JUSTIFICACION = 10;

interface Props {
	campusId: number;
	studentId: number;
	tuition: TuitionDTO;
	currencySymbol: string;
	onClose: () => void;
	onDone: () => void;
}

const http = HttpManager.getInstance();

const errorDe = (e: any): string => {
	const d = e?.response?.data;
	if (d?.errors && typeof d.errors === "object") {
		const v = d.errors[Object.keys(d.errors)[0]];
		if (v) return Array.isArray(v) ? v[0] : String(v);
	}
	return d?.message || d?.error || e?.message || "No se pudo completar. Intenta otra vez.";
};

const etiqueta: React.CSSProperties = { position: "relative", display: "block", fontWeight: 700, margin: "12px 0 4px" };

const CambiarMontoInscripcion: React.FC<Props> = ({ campusId, studentId, tuition, currencySymbol, onClose, onDone }) => {
	const actual = Number(tuition.subTotal?.value) || 0;
	const [monto, setMonto] = useState<string>("");
	const [justificacion, setJustificacion] = useState<string>("");
	const [busy, setBusy] = useState<boolean>(false);
	const [error, setError] = useState<string | null>(null);

	const nuevo = Number(String(monto).replace(/,/g, ""));
	const montoOk = monto.trim() !== "" && isFinite(nuevo) && nuevo > actual + 0.009;
	const justOk = justificacion.trim().length >= MIN_JUSTIFICACION;

	const confirmar = async () => {
		if (!montoOk || !justOk || busy) return;
		try {
			setBusy(true);
			setError(null);
			await http.financesService.cambiarMontoInscripcion(campusId, studentId, tuition.id, { amount: Math.round(nuevo * 100) / 100, justification: justificacion.trim() });
			onDone();
			onClose();
		} catch (e) {
			setError(errorDe(e));
		} finally {
			setBusy(false);
		}
	};

	return (
		<Modal className="waModulo" show onHide={onClose} centered fullscreen="sm-down" style={{ zIndex: 2000 }}>
			<Modal.Header closeButton><Modal.Title style={{ fontSize: 18 }}>Cambiar Monto de Inscripción</Modal.Title></Modal.Header>
			<Modal.Body style={{ textAlign: "left", fontSize: 14 }}>
				{error ? <div role="alert" className="alert alert-danger" style={{ marginBottom: 10 }}>{error}</div> : null}
				<div style={{ color: "var(--wa-apagado)" }}>{tuition.courseName}{tuition.scheduleCode ? " · " + tuition.scheduleCode : ""}</div>
				<div style={{ marginTop: 6 }}>Monto Actual: <b>{tuition.subTotal?.moneyFormat || currencySymbol + actual.toFixed(2)}</b></div>
				<label htmlFor="insc-monto" style={etiqueta}>Monto Nuevo</label>
				<div className="input-group" style={{ maxWidth: 260 }}>
					<span className="input-group-text">{currencySymbol}</span>
					<input id="insc-monto" className="form-control" type="number" inputMode="decimal" min={0} step="0.01" autoFocus style={{ fontSize: 16 }}
						value={monto} disabled={busy} onChange={(e) => setMonto(e.target.value)} />
				</div>
				{monto.trim() !== "" && !montoOk ? <div style={{ fontSize: 12, marginTop: 4, color: "var(--wa-oro)" }}>Mayor que {tuition.subTotal?.moneyFormat || currencySymbol + actual.toFixed(2)}</div> : null}
				<label htmlFor="insc-justificacion" style={etiqueta}>Justificación</label>
				<textarea id="insc-justificacion" className="form-control" rows={3} style={{ fontSize: 16 }} value={justificacion} disabled={busy}
					onChange={(e) => setJustificacion(e.target.value)} />
				<div style={{ fontSize: 12, marginTop: 4, color: justOk ? "var(--wa-apagado)" : "var(--wa-oro)" }}>{justificacion.trim().length}/{MIN_JUSTIFICACION}</div>
			</Modal.Body>
			<Modal.Footer>
				<button type="button" className="btn btn-outline-secondary" disabled={busy} onClick={onClose}>Atrás</button>
				<button type="button" className="btn btn-primary" disabled={busy || !montoOk || !justOk} onClick={confirmar}>Confirmar</button>
			</Modal.Footer>
		</Modal>
	);
};

export default CambiarMontoInscripcion;
